<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useUpdateRoute } from '@/functions'

  const route = useRoute()

  const { updateRoute } = useUpdateRoute()

  const productType = computed({
    set: (product: string) => updateRoute({ detail: product === '0' ? product : undefined }),
    get: () => (route.query.detail ?? '1') as string,
  })
</script>

<template>
  <app-select
    v-model="productType"
    label="Produk">
    <option value="0">
      NonDetil
    </option>
    <option value="1">
      Detil
    </option>
  </app-select>
</template>
